import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { CommonTabs } from '@/components/common'

export const TabsSection = () => {
  const [value, setValue] = useState(0)

  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Basic Usage
      </Typography>
      <CommonTabs
        id='demo-tabs'
        value={value}
        onChange={(e, v) => setValue(v)}
        tabs={[
          {
            label: 'First',
            content: <Typography>First tab content</Typography>,
          },
          {
            label: 'Second',
            content: <Typography>Second tab content</Typography>,
          },
          {
            label: 'Third',
            content: <Typography>Third tab content</Typography>,
          },
        ]}
      />
    </Box>
  )
}
